// reduxjs toolkit
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import BaseUrl from "../../service/API/base_url";
import { handleSuccess, handleError } from "../../utils/toast";

const handleApiResponse = (response, thunkAPI, successMessage) => {
  if (response.status === 200 || response.status === 201) {
    if (successMessage) handleSuccess(successMessage);
    return response.data;
  } else {
    handleError(response.message);
    return thunkAPI.rejectWithValue(response.data);
  }
};

const handleApiError = (error, thunkAPI, errorMessage) => {
  handleError(error.response?.data?.message || errorMessage);
  return thunkAPI.rejectWithValue(error.response?.data);
};

// List all Testimonials
export const viewTestimonials = createAsyncThunk(
  "testimonials",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(`${BaseUrl}backend-api/testimonial`);
      return handleApiResponse(response, thunkAPI);
    } catch (e) {
      return handleApiError(e, thunkAPI, "loading...");
    }
  },
);

// Add new testimonials
export const registerTestimonials = createAsyncThunk(
  "testimonials",
  async (testimonialsData, thunkAPI) => {
    try {
      const response = await axios.post(
        `${BaseUrl}backend-api/testimonial`,
        testimonialsData,
      );

      return handleApiResponse(response, thunkAPI, "Register successful!");
    } catch (e) {
      return handleApiError(e, thunkAPI);
    }
  },
);

// Search Testimonials by ID
export const singleTestimonials = createAsyncThunk(
  "testimonials",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(
        `${BaseUrl}backend-api/testimonial/${id}`,
      );
      return handleApiResponse(response, thunkAPI);
    } catch (e) {
      return handleApiError(e, thunkAPI, "search maintenance history...");
    }
  },
);

// Update Testimonials
export const updateTestimonials = createAsyncThunk(
  "testimonials",
  async ({ id, formData }, thunkAPI) => {
    try {
      const response = await axios.put(
        `${BaseUrl}backend-api/testimonial/${id}`,
        formData,
      );
      return handleApiResponse(response, thunkAPI, "Change saved successfully");
    } catch (e) {
      return handleApiError(e, thunkAPI);
    }
  },
);

// Delete Testimonials
export const deleteTestimonials = createAsyncThunk(
  "testimonials",
  async (id, thunkAPI) => {
    const token = JSON.parse(localStorage.getItem("userInfo")) || null;
    try {
      const response = await axios.delete(
        `${BaseUrl}backend-api/testimonial/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      return handleApiResponse(response, thunkAPI, "Delete successful!");
    } catch (e) {
      return handleApiError(e, thunkAPI);
    }
  },
);
